import script from "./CartView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartView.vue?vue&type=script&lang=ts&setup=true"

import "./CartView.vue?vue&type=style&index=0&id=205b8121&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-205b8121"]])

export default __exports__